import type { ReceiptTemplate } from '../schema';

export const louisVuittonTemplate: ReceiptTemplate = {
  id: 'louis-vuitton',
  name: 'Louis Vuitton Receipt',
  brand: 'LOUIS VUITTON',
  description: 'Luxury fashion house receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'lv-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/louis-vuitton.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'lv-trans-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'lv-date', label: 'Date:', value: '01/04/2026' },
          { id: 'lv-time', label: 'Time:', value: '14:23:41' },
          { id: 'lv-trans', label: 'Trans #:', value: '847291' },
        ],
        column2: [
          { id: 'lv-store', label: 'Store:', value: '0127' },
          { id: 'lv-reg', label: 'Register:', value: '02' },
          { id: 'lv-assoc', label: 'Associate:', value: 'JAMES S.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'lv-customer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Customer: MIKE WAZOWSKI\nMember ID: 79999001708844',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lv-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'lv-item-1', name: 'Neverfull MM Tote', quantity: '1', price: '1960.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'lv-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'lv-subtotal', label: 'Subtotal', value: '1,960.00', isBold: false, isLarge: false },
          { id: 'lv-tax', label: 'Tax (8.875%)', value: '173.95', isBold: false, isLarge: false },
          { id: 'lv-total', label: 'TOTAL', value: '2,133.95', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'lv-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'lv-card-type', label: 'Payment', value: 'VISA' },
          { id: 'lv-card-num', label: 'Card', value: '************4144' },
          { id: 'lv-auth', label: 'Auth Code', value: '059746' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'lv-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'LV847291012726',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'lv-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for shopping at Louis Vuitton.\nReturns accepted within 30 days\nwith original receipt.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

